import React from "react";
import { Divider as PDivider } from 'primereact/divider';
import {extract, renderValue} from "../utils";

const Divider = ({extraConfig, ...rest}) => {
    const {badge = false, title = '', line_type = 'solid', classes ='', size =''} = extraConfig

    let inner = <></>
    if(title){
        inner = <span className={`${badge ? 'p-tag' : ''} ${size ? `text-${size}` : ''} ${classes}`}>{renderValue( title, extraConfig )}</span>
    }
    return <PDivider type={line_type} {...extract( {align: 'center', layout: undefined}, extraConfig)} >{inner}</PDivider>
};
export const FormDivider = Divider;
